import { useCallback, useState } from 'react';
import MainStroLight from './MainStroLight';
import './nuevoStroLight.css';
import PanelIzqStroLight from './PanelIzqStroLight';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import FrentePdf from '../../pdf/Frente';
import PDF from '../../pdf/Sicobe';
import { PDFDownloadLink } from '@react-pdf/renderer';
import sharepoint from '../../../images/sharepoint.jpeg';
import sharepointRojo from '../../../images/shareRojo.png';
import { useCookies } from 'react-cookie';

export default function NuevoStroLight({
  stro,
  carga3,
  estados,
  estadosCodigos,
  frente,
  sicobe,
  planillaReclamos,
  cargando,
  carga2,
  pagosAnteriores,
  cobert,
  carga4,
  reclamo,
  planilla,
  setPlanilla,
  valoresReclamos,
  reclamoSeleccionado,
  setReclamoSeleccionado,
  reclamos,
  reclamoSeleccionadoNuevo,
  setReclamoSeleccionadoNuevo,
  nuevoReclamo,
  setNuevoReclamo,
  terminoCargarTodoImportante,
}) {
  const [nro, setNro] = useState(null);
  const [cookies] = useCookies(['user']);
  const [link1, setLink1] = useState({ link: stro?.link });
  const navigate = useNavigate();

  const buscarNro = useCallback(
    async e => {
      e.preventDefault();
      try {
        const response = await axios.get('https://back.agsseguros.online/api/buscarNroInput', { params: { nro } });
        const data = response.data;
        navigate(`/${data.id}`);
        window.location.reload();
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },
    [nro]
  );

  const linkUpdate = useCallback(
    async e => {
      e.preventDefault();
      await axios
        .post(`https://back.agsseguros.online/api/denuncia/linkSharepoint`, {
          id: stro.id,
          link: link1.link,
        })
        .then(response => {
          if (response) {
            window.location.reload();
          }
        });
    },
    [stro, link1]
  );

  const handleLinkClick = event => {
    if (stro?.link && !stro.link.startsWith('http')) {
      event.preventDefault();
      window.open(`https://${stro.link}`, '_blank');
    }
  };

  return (
    <div className='contenedorStroLight'>
      <header className='headerStroDark'>
        {stro?.nroStro || stro?.entryId ? (
          <div className='d-flex align-items-center gap-3 text-nowrap flex-shrink-0'>
            <div className='nroStroHeaderNuevo'>{stro.nroStro ? `Siniestro: ${stro.nroStro.toString().substring(3)}` : `Denuncia ${stro.entryId}`}</div>
            <div className='d-flex align-items-center gap-1'>
              <span className='tipoStroNuevo'>Tipo:</span>{' '}
              <span className='valorTipoStroNuevo' style={{ color: stro.tipoStro === 'ACCIDENTE DE TRANSITO' ? '#42C38B' : '#424FC3' }}>
                {stro.tipoStro}
              </span>
            </div>
            <div className='d-flex align-items-center gap-2 ms-3'>
              {carga2 && frente?.qnx !== null ? (
                <PDFDownloadLink document={<FrentePdf denuncia={frente} />} fileName={`frenteStro${stro?.nroStro?.toString().substring(3)}.pdf`} style={{ textDecoration: 'none' }}>
                  {({ loading, url, error, blob }) => (
                    <button id='botonFrente' className='btnDescargarFrenteDark'>
                      FRENTE
                    </button>
                  )}
                </PDFDownloadLink>
              ) : null}
              {carga2 && stro.nroStro && sicobe?.qnx !== null ? (
                <PDFDownloadLink
                  document={<PDF sicobe={sicobe} pagosAnteriores={pagosAnteriores} cobert={cobert} cobertura={stro?.qnx?.ados_cobert} />}
                  fileName={`sicobeStro${stro?.nroStro?.toString().substring(3)}.pdf`}
                  style={{ textDecoration: 'none' }}>
                  {({ loading, url, error, blob }) => (
                    <button id='botonSicobe' className='btnDescargarSicobeLight'>
                      SICOBE
                    </button>
                  )}
                </PDFDownloadLink>
              ) : null}
              {stro.link ? (
                <a href={`${stro.link}`} target='_blank' rel='noopener noreferrer' onClick={handleLinkClick} className="d-flex align-items-center">
                  <img src={sharepoint} alt='Sharepoint' style={{ height: '26px', width: '26px', borderRadius: '4px' }} />
                </a>
              ) : (
                <button className='btnNO d-flex align-items-center' data-bs-toggle='modal' data-bs-target='#exampleModal' style={{ background: 'transparent', border: 'none', padding: 0 }}>
                  <img src={sharepointRojo} alt='Sharepoint' style={{ height: '26px', width: '26px' }} />
                </button>
              )}
              {stro.nroStro !== null ? (
                <a href={`https://ags.webmanager.com.ar/LinkAuth/${cookies.user?.digi}/QWdzbmV0MDgxMQ==/${stro.nroStro.toString().substring(3)}`} target='_blank' rel='noopener noreferrer' className="d-flex align-items-center">
                  <i className='bi bi-file-earmark-text' style={{ fontSize: '26px', color: '#42C3BA' }}></i>
                </a>
              ) : null}
            </div>
          </div>
        ) : (
          <div></div>
        )}
        <div style={{ position: 'relative', flexGrow: 1 }}>
          <div style={{ display: 'flex', justifyContent: 'end', gap: '20px' }}>
            <div className='center'>
              <input
                className='form-control form-control-sm w-75'
                type='number'
                placeholder='Buscar Stro'
                value={nro}
                onChange={e => setNro(e.target.value)}
                onKeyDown={async e => {
                  if (e.key === 'Enter') {
                    buscarNro(e);
                  }
                }}></input>
            </div>
            <Link to='/solicitudes' className='botonCargaStroLight' style={{ textDecoration: 'none' }}>
              RECLAMOS
            </Link>
            <button className='botonCargaStroLight'>CARGA</button>
            <a style={{ textDecoration: 'none' }} href='/#/' className='botonTablaStroLight'>
              TABLA
            </a>
          </div>
        </div>
      </header>
      {cargando ? (
        <main className='mainStroLight'>
          <PanelIzqStroLight stro={stro} carga4={carga4} reclamo={reclamo} planilla={planilla} setPlanilla={setPlanilla} nuevoReclamo={nuevoReclamo} reclamos={reclamos} />
          <MainStroLight
            stro={stro}
            carga3={carga3}
            estados={estados}
            estadosCodigos={estadosCodigos}
            frente={frente}
            sicobe={sicobe}
            carga2={carga2}
            pagosAnteriores={pagosAnteriores}
            cobert={cobert}
            todosEstados={valoresReclamos.estados}
            reclamoSeleccionado={valoresReclamos?.reclamos && reclamoSeleccionado < valoresReclamos.reclamos.length ? valoresReclamos.reclamos[reclamoSeleccionado] : null}
            reclamos={reclamos}
            reclamoSeleccionadoNuevo={reclamos[reclamoSeleccionadoNuevo]}
            setReclamoSeleccionadoNuevo={setReclamoSeleccionadoNuevo}
            nuevoReclamo={nuevoReclamo}
            setNuevoReclamo={setNuevoReclamo}
            terminoCargarTodoImportante={terminoCargarTodoImportante}
          />
        </main>
      ) : (
        <div className='center pt-5'>
          <div className='spinner-border text-success center' role='status'></div>
        </div>
      )}
      <div className='modal fade mt-5' id='exampleModal' tabIndex='-1' aria-labelledby='exampleModalLabel' aria-hidden='true'>
        <div className='modal-dialog'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title' id='exampleModalLabel'>
                Link Sharepoint
              </h5>
              <button type='button' className='btn-close' data-bs-dismiss='modal' aria-label='Close'></button>
            </div>
            <div className='modal-body'>
              <input
                type='text'
                className='w-100 ps-3'
                value={link1.link || ''}
                onChange={e =>
                  setLink1(prevState => ({
                    ...prevState,
                    link: e.target.value,
                  }))
                }
              />
            </div>
            <div className='modal-footer'>
              <button type='button' className='btn btn-secondary' data-bs-dismiss='modal'>
                Cancelar
              </button>
              <button type='button' className='btn btn-primary' onClick={e => linkUpdate(e)}>
                Actualizar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
